import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Captcha} from "../common/Captcha";
import {useState} from "react";

export const DKIMResult = () => {
    const data = useSelector(state => state.validation.dkim);
    const {t} = useTranslation();

    const results = data?.result || [];
    const score = data?.score ?? 0;
    const [captchaVerified, setCaptchaVerified] = useState(false);

    const handleCaptchaVerified = () => setCaptchaVerified(true);
    const handleSubmit = (e) => {
        e.preventDefault();
        alert("this would normally trigger an email");
    };

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8 text-center">
                    <h2 className="mb-3">{t('pages.dkimResults.title')}</h2>
                    <p className="lead">{t('pages.dkimResults.previewInfo')}</p>

                    <div className="card my-4 shadow-sm border-warning">
                        <div className="card-body">
                            <h4 className="card-title">
                                {t('pages.dkimResults.score')}:&nbsp;
                                <span className={`fw-bold ${score < 5 ? 'text-danger' : score < 8 ? 'text-warning' : 'text-success'}`}>
                                    {score} / 10
                                </span>
                            </h4>

                            {results.map((entry, i) => (
                                <div key={i} className="text-start mt-4">
                                    <h5 className="fw-semibold">DKIM Record #{i + 1}</h5>

                                    {entry.mechanisms?.length > 0 && (
                                        <>
                                            <p className="fw-semibold mb-1">{t('pages.dkimResults.mechanisms')}</p>
                                            <ul className="list-unstyled">
                                                {entry.mechanisms.map((mech, idx) => (
                                                    <li key={idx}>
                                                        <code>{mech.key}={mech.value}</code>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    )}

                                    {entry.warnings?.length > 0 && (
                                        <div className="mt-2">
                                    <p className="text-warning fw-semibold">
                                                ⚠️ {t('pages.dkimResults.warningHeader')}
                                    </p>
                                    <ul className="list-unstyled">
                                                {entry.warnings.map((warn, idx) => (
                                            <li key={idx}>
                                                        {t(`pages.dkimResults.warnings.${warn.key}`, {
                                                            value: warn.value ?? warn.key
                                                        })}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                                    {entry.issues?.length > 0 && (
                                        <div className="mt-2">
                                            <p className="text-danger fw-semibold">
                                                ❌ {t('pages.dkimResults.issueHeader')}
                                    </p>
                                    <ul className="list-unstyled">
                                                {entry.issues.map((issue, idx) => (
                                            <li key={idx}>
                                                        {t(`pages.dkimResults.issues.${issue.key}`, {
                                                            value: issue.value ?? issue.key
                                                        })}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                                </div>
                            ))}

                            <div className="mt-4">
                                <p className="text-muted small">{t('pages.dkimResults.partialDisclosure')}</p>
                            </div>
                        </div>
                    </div>

                    <div className="card p-4 shadow-sm mt-4 border-primary">
                        <form onSubmit={handleSubmit}>
                            <p className="fw-semibold mb-3">{t('pages.dkimResults.reportPitch')}</p>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">
                                    {t('pages.dkimResults.emailLabel')}
                                </label>
                                <input type="email" className="form-control" id="email"
                                       placeholder={t('pages.dkimResults.emailPlaceholder')}/>
                            </div>
                            <button type="submit" className="btn btn-primary btn-lg w-100 mb-2 text-white"
                                    disabled={!captchaVerified}>
                                {t('pages.dkimResults.getFullReport')}
                            </button>
                            <Captcha onSolutionVerified={handleCaptchaVerified}/>
                            <p className="text-muted small mt-2">
                                {t('pages.dkimResults.emailDisclaimer')}
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
